/**
 * ENV const khai báo những config sẽ luôn dùng trong các môi trường
 * */
export const envbase = {
   production: false,
   isAdsModule: false,
   apiVersion: 2,
   language: {
      code: 'vi-VN',
      name: 'Vietnamese',
      availableLangs: [
         {
            id: 'vi-VN',
            label: 'Vietnamese'
         },
         {
            id: 'en-US',
            label: 'English'
         }
      ],
   },

   // ------------------------------------------------------------------------------------------------------------------
   // Các config có thể thay đổi trong các môi trường ------------------------------------------------------------------
   // ------------------------------------------------------------------------------------------------------------------
   baseUrl: '',
   baseUrlApi: 'http://vpage.local:4211',
   cloudStorageStatic: {
      vpageStaticUrl: 'https://vpage.static.nvncdn.com/img/'
   },
   /**
    * Cloudflare Worker & CDN config.
    * Dev/local: useTranslationCdn = false -> doc file i18n truc tiep trong project.
    * Pro: useTranslationCdn = true -> load qua Worker -> CDN, fallback ve server goc khi loi.
    */
   cloudFlareService: {
      isActiveDomainStatic: false,
      useTranslationCdn: false,
      url: {
         static: '',
      },
   },
   serverSSR: {
      PORT: 4001,
      USE_RENDERING: false,
   },
   /**
    * Cấu hình Durable Object (Cloudflare Worker WebSocket).
    * - `ws_url`: base URL WebSocket. Để rỗng để tự tắt `DurableObjectService`
    *   (mọi `join*` no-op, không mở connection nào).
    *
    * Mặc định trỏ tới DO dev của Nhanh — các build prod nên override sang URL riêng.
    * @see [ADR-0002](../../../../agent-vpage/tracking/decision-log.md)
    */
   durable_object: {
      ws_url: 'wss://vpage-socket-room-dev.nvndev.workers.dev',
   },
};
